import React, { useState, createContext, useContext } from 'react';
interface PresentationModeContextType {
  isPresentationMode: boolean;
  togglePresentationMode: () => void;
}
const PresentationModeContext = createContext<PresentationModeContextType>({
  isPresentationMode: false,
  togglePresentationMode: () => {}
});
export const usePresentationMode = () => useContext(PresentationModeContext);
interface PresentationModeProviderProps {
  children: ReactNode;
}
export const PresentationModeProvider = ({
  children
}: PresentationModeProviderProps) => {
  const [isPresentationMode, setIsPresentationMode] = useState(false);
  const togglePresentationMode = () => {
    setIsPresentationMode(prev => !prev);
  };
  return <PresentationModeContext.Provider value={{
    isPresentationMode,
    togglePresentationMode
  }} data-id="element-4284">
      {children}
    </PresentationModeContext.Provider>;
};